<template>
  <table class="dataTable">
    <thead v-if="value.header">
      <tr v-for="(row, rowInd) in value.header" :key="rowInd">
        <td v-for="(cell, colInd) in row" :style="cell.style" :rowspan="cell.rowSpan" :colspan="cell.colSpan" :key="colInd">
          {{ cell.value }}
        </td>
      </tr>
    </thead>
    <!-- <colgroup>
      <col v-for="(column, colInd) in value.columns" :style="{ width: `${column.width}px` }" :key="colInd" />
    </colgroup> -->
    <tbody>
      <tr v-for="(row, rowInd) in value.data" :key="rowInd">
        <td v-for="(cell, colInd) in row" :style="cell.style" :rowspan="cell.rowSpan" :colspan="cell.colSpan" :key="colInd" v-show="!noShowMergedCells.includes(cell)">
          {{ cell.value }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { getMergedCells } from '../../../libraries/tables';
export default {
  props: ['value'],
  methods: {
    filterOutMergedCells(row) {
      return row.filter(cell => !this.noShowMergedCells.includes(cell));
    },
  },
  computed: {
    noShowMergedCells() {
      return getMergedCells(this.value.data)
        .flatMap(f => f.cells.tail().map(g => g.cell));
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window.thisTablePreview = this;
  },
};
</script>

<style lang="scss" scoped>
.dataTable {
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  flex: 1;
  width: 100%;
  max-width: 100%;
  background-color: #ffffff;
  color: #606266;
  font-size: 16px;
  border-spacing: 0;

  thead {
    color: #909399;
    font-weight: 500;
  }

  tr:hover {
    background: #f5f7fa;
  }

  th {
    overflow: hidden;
    background-color: #ffffff;

    &.fixed {
      width: 1px;
    }
  }

  th,
  td {
    padding: 12px 8px;
    min-width: 0;
    box-sizing: border-box;
    text-overflow: ellipsis;
    vertical-align: middle;
    position: relative;
    text-align: left;
    border-bottom: 1px solid #ebeef5;
  }

  a {
    &.nav-item {
      color: rgb(96, 98, 102);
    }
    &:hover {
      color: rgb(96, 98, 102);
    }
  }
}
</style>